import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { PlatformService } from 'ngx-unificator/services';
import { UntilDestroy } from 'ngx-unificator/decorator';

@UntilDestroy()
@Directive({
  selector: '[wrapHtml]'
})
export class WrapHtmlDirective implements AfterViewInit, OnChanges {
  private _el = inject(ElementRef);
  private _renderer = inject(Renderer2);
  private _platform = inject(PlatformService);

  readonly rule = input<any>('');

  ngAfterViewInit() {
    this._wrapHtml();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rule']) {
      this._wrapHtml();
    }
  }

  private _wrapHtml() {
    if (this._platform.isBrowser) {
      const element = this._el.nativeElement;
      const brTags = element.querySelectorAll('br');

      brTags.forEach((brTag) => {
        const nextNode = brTag.nextSibling;

        if (nextNode && nextNode.nodeType === Node.TEXT_NODE && nextNode.textContent?.trim()) {
          const span = this._renderer.createElement('span');
          this._renderer.appendChild(span, this._renderer.createText(nextNode.textContent.trim()));

          this._renderer.insertBefore(element, span, nextNode);
          this._renderer.removeChild(element, nextNode);
        }

        this._renderer.removeChild(element, brTag);
      });
    }
  }
}
